import React from 'react';
import PropTypes from 'prop-types';
import { login, resetPassword } from '../helpers/auth';
import { Redirect } from 'react-router-dom';

function setErrorMsg(error) {
  return {
    loginMessage: error
  };
}

class Login extends React.Component {
  state = { loginMessage: null };
  handleSubmit = (e) => {
    e.preventDefault();
    login(this.email.value, this.pw.value)
      // .then((user) => {
      //   this.setState({ authed: true });
      // })
      .catch((error) => {
        this.setState(setErrorMsg('Invalid username/password.'));
      });
  }
  resetPassword = () => {
    resetPassword(this.email.value)
      .then(() => this.setState(setErrorMsg('Password reset email sent to ${this.email.value}.')))
      .catch((error) => this.setState(setErrorMsg('Email address not found.')));
  }
  render() {
    console.log(this.props.authed);
    if(!this.props.authed) {
      return (
        <div>
          <div className="panel panel-form panel-login">
            <div className="panel-header">
              <h1>Login</h1>
            </div>
            <form onSubmit={this.handleSubmit}>
              <div className="form-item">
                <label>Email</label>
                <input className="form-field" ref={(email) => (this.email = email)} />
              </div>
              <div className="form-item">
                <label>Password</label>
                <input type="password" className="form-field" ref={(pw) => (this.pw = pw)} />
              </div>
              <div className="form-item">
                <a href="#" onClick={this.resetPassword} className="alert-link forgot-password">Forgot your password?</a>
              </div>
              {
                this.state.loginMessage &&
                <div className="alert alert-danger" role="alert">
                  <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                  <span className="sr-only">Error:</span>
                  &nbsp;{this.state.loginMessage} <a href="#" onClick={this.resetPassword} className="alert-link">Forgot your password?</a>
                </div>
              }
              <div className="form-item form-center form-button">
                <button type="submit" className="btn btn-primary">Log In</button>
              </div>
            </form>
          </div>
        </div>
      );
    }
    return (
      <Redirect to="/" />
    );
  }
}

Login.propTypes = {
  location: PropTypes.any,
  authed: PropTypes.any
};

export default Login;



// WEBPACK FOOTER //
// ./client/components/Login.js